import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import CreateIcon from "../../Icons/CreateIcon";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import Spinner from "../../components/Reusable/Spinner";
import { toast } from "react-toastify";
import Skeleton from "../../components/Reusable/Skeleton";
const CreateRoleComponent = loadable(
  () => import("../../components/Role/CreateRole")
);
const CreateRole = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["roles"],
    navigateURL: "/roles",
  });

  const { data: Permissions, isLoading: isPermissionsLoading } = useGetHook({
    queryKey: [`logesticPermissions`],
    url: `${APIS.PERMISSIONS}`,
    params: {},
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.GROUP}`;
    if (values?.custom_permissions?.length === 0) {
      toast.error("Please select at least one permission");
      return;
    }
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Role
        </span>
      </div>
      {isPermissionsLoading ? (
        <Skeleton />
      ) : (
        <CreateRoleComponent
          isLoading={isPostLoading}
          handleCreate={handleCreate}
          Permissions={Permissions}
          isPermissionsLoading={isPermissionsLoading}
        />
      )}
    </>
  );
};

export default CreateRole;
